import styled from "styled-components";
import { default as BaseMapStatic } from "../../../common/MapStatic";
import { default as BaseImage } from "../../../common/Image";

export const Container = styled.div`
  width: 100%;
  max-width: 85.6rem;
  margin: auto;
  padding: 0 2.4rem;
  margin-top: 3rem;

  ${({ theme }) => theme.media.sm`
    margin: 2.4rem 0;
  `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: top;
  margin-bottom: 3rem;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 85.6rem;
  margin: auto;
  padding: 0 2.4rem;

  ${({ theme }) => theme.media.sm`
  margin: 2.4rem 0;
`}
`;

export const HeaderEdit = styled.div`
  position: absolute;
  right: 1.5rem;
  margin-top: 6rem;
  margin-left: auto;
  ${({ theme }) => theme.media.sm`
  margin-top: -7.35em;
  z-index: 101;`}
`;

export const EditIcon = styled.div`
  margin-right: 1rem;

  svg {
    width: 2rem;
    height: 2rem;
    fill: ${({ theme }) => theme.live.colors.primary};
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 4.8rem;
  font-weight: 600;
  line-height: 5.2rem;
  color: ${({ theme }) => theme.live.colors.primary};
  margin-top: 3rem;
  ${({ theme }) => theme.media.sm`
    font-size: 3.2rem;
    line-height: 3.5rem;
    margin-top:6rem;
  `}
`;

export const Address = styled.div`
  margin-top: 6rem;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  margin-bottom: 0.8rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[700]};
  flex: 0 1 auto;
  left: 50%;
  right: 50%;
  transform: translateX(-50%);
  position: relative;
  text-align: center;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Stats = styled.div`
  margin-bottom: 2.4rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  border-radius: 0.4rem;
  overflow: hidden;
`;

export const StatsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${({ theme }) => theme.media.sm`
    flex-direction: column;
  `}
`;

export const StatsCell = styled.div`
  display: flex;
  width: 50%;

  ${({ theme }) => theme.media.sm`
    width: 100%;
  `}

  &:last-child {
    padding: 2.4rem;
  }
`;

export const StatsTitle = styled.div`
  padding-top: 2.5rem;
  padding-bottom: 1rem;
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
  line-height: 2.6rem;
  text-align: center;
`;

export const StatsFilters = styled.div`
  display: flex;
  padding: 1rem;
  font-style: normal;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const StatsFilter = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 0 2rem 0 2rem;
  border-radius: 6px;
  color: ${({ theme, isActive }) =>
    isActive ? theme.live.colors.primary : theme.live.colors.secondary};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.styleGuide.colors.gray[300] : "white"};

  &:hover {
    cursor: pointer;
  }
`;

export const StatsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border: 1px solid ${({ theme }) => theme.styleGuide.colors.gray[500]};
  border-radius: 6px;
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  margin: 0px 0px;

  &:first-child {
    border-right: 1px solid ${({ theme }) => theme.styleGuide.colors.gray[400]};
  }
`;

export const StatImageContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[500]};
`;

export const MapStatic = styled(BaseMapStatic)`
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[400]};
  ${({ theme }) => theme.media.sm`
    width: 100%;
    height: 20.4rem;
  `}
`;

export const StatImage = styled(BaseImage)`
  height: 100%;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[400]};

  ${({ theme }) => theme.media.sm`
    width: 100%;
    height: 20.4rem;
  `}
`;

export const StatLabel = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 2px 0px
    ${({ theme }) => theme.media.sm`
    font-size: 1.2rem;
    line-height: 1.6rem;
  `};
`;

export const StatValue = styled.div`
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 3rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 2px 0px;

  ${({ theme }) => theme.media.sm`
    font-size: 1.8rem;
    line-height: 2.4rem;
  `}
`;

export const StatPercentage = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6rem;
  color: ${({ theme, isAbove }) =>
    isAbove
      ? theme.styleGuide.colors.green[700]
      : theme.styleGuide.colors.red[600]};
  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 2px 0px;
  ${({ theme }) => theme.media.sm`
    font-size: 1rem;
    line-height: 1.4rem;
  `}
`;

export const EditNetSheet = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 3rem;
  padding: 0 1.8rem 0 1.8rem;
  border-radius: 6px;
  color: ${({ theme }) => theme.live.colors.primary};
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[300]};

  &:hover {
    cursor: pointer;
  }
`;

export const Estimate = styled.div`
  padding: 2.4rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  border-radius: 0.4rem;
  margin-bottom: 25px;
`;

export const EstimateTitle = styled.h3`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 3rem;
  margin-bottom: 2.4rem;
  padding-bottom: 1.4rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  border-bottom: 0.1rem solid
    ${({ theme }) => theme.styleGuide.colors.gray[400]};
  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
    line-height: 1.8rem;
    margin-bottom: 1.2rem;
  `}
`;

export const EstimateCalculations = styled.div`
  margin-top: 1.2rem;
`;

export const EstimateRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  margin-left: ${({ isChild }) => isChild && "2.4rem"};
  padding: 1rem 0;
  color: ${({ theme, isChild }) =>
    isChild
      ? theme.styleGuide.colors.gray[700]
      : theme.styleGuide.colors.gray[900]};
  border-bottom: 0.1rem solid
    ${({ theme }) => theme.styleGuide.colors.gray[400]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}

  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
`;

export const Total = styled.strong`
  font-size: 2rem;
  font-weight: 600;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const EstimateDisclaimer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
  justify-content: center;
  margin-top: 0.4rem;
`;

export const EstimatedColumnOne = styled.div`
  width: 80%;
`;

export const EstimatedColumnTwo = styled.div`
  width: 10%;
`;

export const EstimatedColumnThree = styled.div`
  width: 10%;
  text-align: right;
`;
export const RangeSliderWrapper = styled.div`
  ${({ theme }) => theme.media.sm`
  & > div > div:nth-child(2) {
    width: 100%;
  }
  width:100%;`}
`;

export const DrawerWrapper = styled.div`
  max-width: 45rem;
  height: 100%;
`;
